import { api } from '@shared/api';
import type { FloorPlanData } from '@shared/types/floorPlans';

export const getFloorPlansForRestaurantId = async (
  restaurantId: string,
  signal?: AbortSignal,
): Promise<FloorPlanData[]> =>
  api.get<FloorPlanData[]>(`/restaurants/${restaurantId}/floor-plans`, {
    signal,
  });

export const getFloorPlanByNameSlug = async (
  restaurantId: string,
  nameSlug: string,
  signal?: AbortSignal,
) =>
  api.get<FloorPlanData>(
    `/restaurants/${restaurantId}/floor-plans/${nameSlug}`,
    { signal },
  );
